import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { iller, ilceler, tumMekanlar } from '../../components/routesData';

// MUI Components
import {
    TextField, Autocomplete, CircularProgress, Button, Modal, Box, Typography,
    Tabs, Tab, Card, CardContent, CardMedia, Chip, IconButton, Grid, Divider, List, ListItem, ListItemText, ListItemIcon
} from '@mui/material';

// Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaceIcon from '@mui/icons-material/Place';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import MapIcon from '@mui/icons-material/Map';

// --- API Adresi ---
const API_URL = process.env.REACT_APP_API_URL;

// Küçük uyarı modalları için stil
const alertModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#1f2937', 
    border: '2px solid #374151',
    boxShadow: 24,
    p: 4,
    borderRadius: '12px',
    color: 'white',
    outline: 'none',
};

// --- GÜNCELLENMİŞ DETAY MODAL STİLİ (SCROLL KALDIRILDI) ---
const detailModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 800,
    // maxHeight: '90vh', // KALDIRILDI: Artık içerik kadar uzayacak
    // overflowY: 'auto', // KALDIRILDI: Kendi içinde scroll olmayacak
    bgcolor: '#111827',
    border: '1px solid #374151',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    p: 0,
    borderRadius: '16px',
    color: 'white',
    outline: 'none',
    my: 4, // Sayfa scroll olduğunda üst ve alttan biraz boşluk kalsın
};

// Input Stilleri
const inputStyles = {
    '& .MuiOutlinedInput-root': {
        color: 'white', 
        backgroundColor: '#1f2937',
        '& fieldset': { borderColor: '#4b5563' },
        '&:hover fieldset': { borderColor: '#9ca3af' },
        '&.Mui-focused fieldset': { borderColor: '#2dd4bf' },
    },
    '& .MuiInputLabel-root': { color: '#9ca3af' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#2dd4bf' }
};

const AdminRotaYonetimi = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0); 
    const [mevcutRotalar, setMevcutRotalar] = useState([]);
    const [listLoading, setListLoading] = useState(false);

    // Form State'leri
    const [rotaAdi, setRotaAdi] = useState('');
    const [rotaAciklamasi, setRotaAciklamasi] = useState('');
    const [ortalamaSure, setOrtalamaSure] = useState('');
    const [nelerOgreneceksinizText, setNelerOgreneceksinizText] = useState('');
    const [rotaGorseliFile, setRotaGorseliFile] = useState(null);
    const [rotaGorseliPreview, setRotaGorseliPreview] = useState(null);
    const [yuklenenGorselUrl, setYuklenenGorselUrl] = useState('');
    const [secilenIl, setSecilenIl] = useState('');
    const [secilenIlce, setSecilenIlce] = useState('');
    const [mevcutIlceler, setMevcutIlceler] = useState([]);
    const [arananMekanAdi, setArananMekanAdi] = useState('');
    const [arananMekanBilgi, setArananMekanBilgi] = useState('');
    const [arananMekanLat, setArananMekanLat] = useState('');
    const [arananMekanLon, setArananMekanLon] = useState('');
    const [eklenenMekanlar, setEklenenMekanlar] = useState([]);
    const [filtreliMekanOnerileri, setFiltreliMekanOnerileri] = useState([]);
    const [secilenMekanObj, setSecilenMekanObj] = useState(null);
    const [formYukleniyor, setFormYukleniyor] = useState(false);
    
    // Modal State
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', message: '' });
    const [isSuccessModal, setIsSuccessModal] = useState(false);
    const [detayModalOpen, setDetayModalOpen] = useState(false);
    const [secilenRotaDetay, setSecilenRotaDetay] = useState(null);

    // --- LİSTELEME ---
    const fetchRotalar = async () => {
        setListLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URL}/admin/rotalar`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setMevcutRotalar(response.data);
        } catch (error) {
            openModal("Hata", "Rotalar yüklenirken hata oluştu.", false);
        } finally {
            setListLoading(false);
        }
    };

    const handleDeleteRota = async (id) => {
        if (!window.confirm("Bu rotayı silmek istediğinize emin misiniz?")) return;
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${API_URL}/admin/rotalar/${id}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setMevcutRotalar(mevcutRotalar.filter(rota => rota.id !== id));
            openModal("Başarılı", "Rota silindi.", true);
        } catch (error) {
            openModal("Hata", "Silme başarısız.", false);
        }
    };

    useEffect(() => {
        if (activeTab === 0) fetchRotalar();
    }, [activeTab]);

    // --- FORM YARDIMCILARI ---
    useEffect(() => {
        if (secilenIl) {
            setMevcutIlceler(ilceler[secilenIl] || []);
            setSecilenIlce('');
        } else {
            setMevcutIlceler([]);
            setSecilenIlce('');
        }
    }, [secilenIl]);

    useEffect(() => {
        if (rotaGorseliFile) {
            const reader = new FileReader();
            reader.onloadend = () => setRotaGorseliPreview(reader.result);
            reader.readAsDataURL(rotaGorseliFile);
        } else { setRotaGorseliPreview(null); }
    }, [rotaGorseliFile]);

    useEffect(() => {
        let filtrelenmis = tumMekanlar;
        if (secilenIl) filtrelenmis = filtrelenmis.filter(mekan => mekan.il === iller.find(il => il.id === secilenIl)?.name);
        if (secilenIlce) filtrelenmis = filtrelenmis.filter(mekan => mekan.ilce === mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name);
        setFiltreliMekanOnerileri(filtrelenmis);
    }, [secilenIl, secilenIlce, mevcutIlceler]);

    useEffect(() => {
        if (secilenMekanObj) {
            setArananMekanAdi(secilenMekanObj.ad);
            setArananMekanBilgi(secilenMekanObj.bilgi || '');
            setArananMekanLat(String(secilenMekanObj.latitude || ''));
            setArananMekanLon(String(secilenMekanObj.longitude || ''));
            const selectedIlId = iller.find(il => il.name === secilenMekanObj.il)?.id || '';
            setSecilenIl(selectedIlId);
            if (selectedIlId) {
                const correspondingIlces = ilceler[selectedIlId] || [];
                setMevcutIlceler(correspondingIlces);
                setSecilenIlce(correspondingIlces.find(ilce => ilce.name === secilenMekanObj.ilce)?.id || '');
            }
        }
    }, [secilenMekanObj]);

    const openModal = (title, message, isSuccess) => {
        setModalContent({ title, message });
        setIsSuccessModal(isSuccess);
        setIsModalOpen(true);
    };
    const handleCloseModal = () => setIsModalOpen(false);

    const handleDetayAc = (rota) => {
        setSecilenRotaDetay(rota);
        setDetayModalOpen(true);
    };
    const handleDetayKapat = () => {
        setDetayModalOpen(false);
        setSecilenRotaDetay(null);
    };

    // MEKAN EKLEME (DUPLICATE KONTROLÜ)
    const handleMekanEkle = () => {
        const mekanAdi = arananMekanAdi.trim();
        if (mekanAdi === '') { openModal("Uyarı", "Mekan adı girin.", false); return; }
        const isDuplicate = eklenenMekanlar.some(mekan => mekan.ad.toLowerCase() === mekanAdi.toLowerCase());
        if (isDuplicate) { openModal("Uyarı", "Bu mekan zaten listeye eklenmiş.", false); return; }

        const newMekan = {
            id: Date.now(),
            ad: mekanAdi,
            bilgi: arananMekanBilgi.trim() || 'Ek bilgi yok.',
            il: iller.find(il => il.id === secilenIl)?.name || 'Bilinmiyor',
            ilce: mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name || 'Bilinmiyor',
            latitude: arananMekanLat ? parseFloat(arananMekanLat) : null,
            longitude: arananMekanLon ? parseFloat(arananMekanLon) : null,
        };
        setEklenenMekanlar([...eklenenMekanlar, newMekan]);
        setArananMekanAdi(''); setArananMekanBilgi(''); setArananMekanLat(''); setArananMekanLon(''); setSecilenMekanObj(null);
    };

    const handleRotayiKaydet = async (e) => {
        e.preventDefault();
        setFormYukleniyor(true);
        const token = localStorage.getItem('token');
        if (!token) { navigate('/login'); return; }

        if (!rotaAdi || !rotaAciklamasi || eklenenMekanlar.length === 0) {
            openModal("Hata", "Gerekli alanları doldurun.", false);
            setFormYukleniyor(false); return;
        }

        let finalGorselUrl = '';
        if (rotaGorseliFile) {
            const formData = new FormData();
            formData.append('file', rotaGorseliFile);
            try {
                const uploadResponse = await axios.post(`${API_URL}/api/upload-image/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` }
                });
                finalGorselUrl = uploadResponse.data.url;
            } catch (err) { setFormYukleniyor(false); return; }
        } else if (yuklenenGorselUrl) { finalGorselUrl = yuklenenGorselUrl; }

        const newRotaData = {
            baslik: rotaAdi,
            aciklama: rotaAciklamasi,
            ortalamaSure: ortalamaSure,
            gorsel: finalGorselUrl || null,
            icerdiğiYapılar: eklenenMekanlar.map(m => m.ad),
            mekanDetaylari: eklenenMekanlar,
            nelerOgreneceksiniz: nelerOgreneceksinizText.split('\n').filter(i => i.trim() !== ''),
            il: eklenenMekanlar[0]?.il,
            ilce: eklenenMekanlar[0]?.ilce,
        };

        try {
            await axios.post(`${API_URL}/admin/rotalar`, newRotaData, {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
            });
            openModal("Başarılı", "Rota oluşturuldu!", true);
            setRotaAdi(''); setRotaAciklamasi(''); setOrtalamaSure('');
            setEklenenMekanlar([]); setRotaGorseliPreview(null); setRotaGorseliFile(null);
            setActiveTab(0);
        } catch (error) { openModal("Hata", 'Hata oluştu.', false); } 
        finally { setFormYukleniyor(false); }
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white p-4 md:p-8">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                    <Button onClick={() => navigate('/route')} variant="outlined" startIcon={<ArrowBackIcon />} className="text-gray-400 border-gray-600 hover:bg-gray-800">Panele Dön</Button>
                    <div className="text-center md:text-right">
                        <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">Rota Yönetim Paneli</h1>
                        <p className="text-gray-400 text-sm mt-1">Sistem ve Kullanıcı rotalarını yönetin</p>
                    </div>
                </div>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
                    <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)} textColor="inherit" indicatorColor="secondary"
                        sx={{ '& .MuiTab-root': { color: '#9ca3af', fontWeight: 'bold' }, '& .Mui-selected': { color: '#2dd4bf !important' }, '& .MuiTabs-indicator': { backgroundColor: '#2dd4bf' } }}>
                        <Tab icon={<ListAltIcon />} iconPosition="start" label="Mevcut Rotalar" />
                        <Tab icon={<AddLocationAltIcon />} iconPosition="start" label="Yeni Rota Oluştur" />
                    </Tabs>
                </Box>

                {activeTab === 0 && (
                    <div className="space-y-6">
                        {listLoading ? (
                            <div className="flex justify-center p-12"><CircularProgress className="text-teal-400" /></div>
                        ) : mevcutRotalar.length === 0 ? (
                            <div className="text-center p-12 bg-gray-800 rounded-xl border border-gray-700"><Typography className="text-gray-400">Rota bulunamadı.</Typography></div>
                        ) : (
                            <Grid container spacing={3}>
                                {mevcutRotalar.map((rota) => (
                                    <Grid item xs={12} md={6} lg={4} key={rota.id}>
                                        <Card sx={{ bgcolor: '#1f2937', color: 'white', borderColor: '#374151', display: 'flex', flexDirection: 'column', height: '450px', width: '350px' }}
                                            className="border border-gray-700 hover:border-teal-500 transition-all duration-300 shadow-lg rounded-xl overflow-hidden">
                                            <div className="relative h-[180px] bg-gray-800 flex-shrink-0">
                                                {rota.gorsel ? ( <CardMedia component="img" image={rota.gorsel} alt={rota.baslik} className="h-full w-full object-cover" /> ) : (
                                                    <div className="h-full w-full flex flex-col items-center justify-center text-gray-500 bg-gray-700"><ImageNotSupportedIcon fontSize="large" className="mb-2 opacity-50"/><span className="text-sm">Görsel Yok</span></div>
                                                )}
                                                {/* GÜNCELLENMİŞ CHIP STİLİ */}
                                                <div className="absolute top-3 left-3">
                                                    <Chip 
                                                        icon={rota.is_public ? <AdminPanelSettingsIcon className="!text-white !text-sm" /> : <PersonIcon className="!text-white !text-sm"/>} 
                                                        label={rota.is_public ? "Sistem Rotası" : "Kullanıcı Rotası"} 
                                                        size="small" 
                                                        sx={{
                                                            backgroundColor: rota.is_public ? 'rgba(79, 70, 229, 0.9)' : 'rgba(22, 163, 74, 0.9)',
                                                            color: 'white',
                                                            fontWeight: 600,
                                                            backdropFilter: 'blur(4px)',
                                                            border: '1px solid rgba(255,255,255,0.1)',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2, overflow: 'hidden' }}>
                                                <div className="flex items-center text-teal-400 text-xs font-semibold uppercase tracking-wider mb-2">
                                                    <LocationOnIcon fontSize="inherit" className="mr-1" />{rota.il ? `${rota.il} / ${rota.ilce}` : 'Konum Belirtilmemiş'}
                                                </div>
                                                <Typography variant="h6" component="div" className="text-white font-bold leading-tight mb-2" noWrap>{rota.baslik}</Typography>
                                                <Typography variant="body2" className="text-gray-400 mb-2" sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3 }}>{rota.aciklama || 'Açıklama bulunmuyor.'}</Typography>
                                                <div className="mt-auto pt-2 w-full">
                                                    {rota.ortalamaSure && (<div className="flex items-center text-gray-500 text-xs mb-3"><AccessTimeIcon fontSize="small" className="mr-1" /><span>Ortalama: {rota.ortalamaSure}</span></div>)}
                                                    <Divider sx={{ borderColor: '#374151', mb: 2 }} />
                                                    <div className="flex justify-end gap-2">
                                                        <Button size="small" variant="outlined" color="info" startIcon={<VisibilityIcon />} onClick={() => handleDetayAc(rota)} className="border-blue-500/50 text-blue-400 hover:bg-blue-900/20 hover:border-blue-500">Ayrıntılar</Button>
                                                        <Button size="small" variant="outlined" color="error" startIcon={<DeleteOutlineIcon />} onClick={() => handleDeleteRota(rota.id)} className="border-red-500/50 text-red-400 hover:bg-red-900/20 hover:border-red-500">Sil</Button>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </div>
                )}

                {activeTab === 1 && (
                    <form onSubmit={handleRotayiKaydet} className="space-y-8 animate-fadeIn">
                         {formYukleniyor && (<div className="flex items-center justify-center gap-3 p-4 bg-gray-800 text-teal-400 rounded-lg border border-gray-700 shadow-md animate-pulse"><CircularProgress size={20} className="text-teal-400" /><span className="font-medium">İşleniyor...</span></div>)}
                        <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg">
                            <h2 className="text-xl font-bold text-teal-400 mb-6 border-b border-gray-700 pb-2">1. Genel Bilgiler</h2>
                            <div className="grid md:grid-cols-2 gap-6 mb-6">
                                <TextField label="Rota Adı" value={rotaAdi} onChange={(e) => setRotaAdi(e.target.value)} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                <TextField label="Ortalama Süre" value={ortalamaSure} onChange={(e) => setOrtalamaSure(e.target.value)} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                            </div>
                            <TextField label="Rota Açıklaması" value={rotaAciklamasi} onChange={(e) => setRotaAciklamasi(e.target.value)} multiline rows={3} fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />
                            <div className="mt-6">
                                <label className="block text-gray-400 text-sm mb-2 font-medium">Kapak Görseli</label>
                                <div className="flex items-center gap-4">
                                    <Button component="label" variant="contained" className="bg-gray-700 hover:bg-gray-600 text-white capitalize">Dosya Seç <input type="file" hidden accept="image/*" onChange={(e) => setRotaGorseliFile(e.target.files?.[0])} /></Button>
                                    {rotaGorseliPreview && <img src={rotaGorseliPreview} alt="Preview" className="h-20 w-32 object-cover rounded-md border border-gray-600 shadow-sm" />}
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg">
                            <h2 className="text-xl font-bold text-teal-400 mb-6 border-b border-gray-700 pb-2">2. Rota Durakları</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <div className="flex flex-col"><label className="text-gray-400 text-xs mb-1 ml-1">İl Seçin</label><select className="bg-gray-900 text-white p-3 rounded border border-gray-600 focus:border-teal-500 focus:outline-none" value={secilenIl} onChange={(e) => setSecilenIl(e.target.value)}><option value="" className="text-gray-500">İl Seçin...</option>{iller.map(il => <option key={il.id} value={il.id}>{il.name}</option>)}</select></div>
                                <div className="flex flex-col"><label className="text-gray-400 text-xs mb-1 ml-1">İlçe Seçin</label><select className="bg-gray-900 text-white p-3 rounded border border-gray-600 focus:border-teal-500 focus:outline-none disabled:opacity-50" value={secilenIlce} onChange={(e) => setSecilenIlce(e.target.value)} disabled={!secilenIl}><option value="" className="text-gray-500">İlçe Seçin...</option>{mevcutIlceler.map(ilce => <option key={ilce.id} value={ilce.id}>{ilce.name}</option>)}</select></div>
                            </div>
                            <Autocomplete freeSolo options={filtreliMekanOnerileri} getOptionLabel={(option) => typeof option === 'string' ? option : (option.ad || '')} value={secilenMekanObj} onChange={(e, newValue) => setSecilenMekanObj(newValue)} inputValue={arananMekanAdi} onInputChange={(e, val) => { setArananMekanAdi(val); if(val !== arananMekanAdi) setSecilenMekanObj(null); }} renderInput={(params) => (<TextField {...params} label="Mekan Adı Ara" fullWidth InputLabelProps={{ shrink: true }} sx={inputStyles} />)} PaperComponent={({ children }) => <div className="bg-gray-700 text-white border border-gray-600 mt-1 rounded-md shadow-lg">{children}</div>} />
                            <Button variant="contained" onClick={handleMekanEkle} startIcon={<AddCircleOutlineIcon />} className="mt-4 w-full bg-teal-600 hover:bg-teal-700 py-3 font-semibold">Listeye Ekle</Button>
                            
                            <div className="mt-8">
                                {eklenenMekanlar.length > 0 && (<ul className="space-y-2">{eklenenMekanlar.map((mekan, index) => (<li key={mekan.id} className="flex justify-between items-center bg-gray-900/50 p-4 rounded-lg border border-gray-700"><div className="flex items-center"><span className="flex items-center justify-center w-6 h-6 rounded-full bg-teal-500/20 text-teal-400 text-xs font-bold mr-3">{index + 1}</span><div><div className="text-white font-medium">{mekan.ad}</div><div className="text-gray-500 text-xs">{mekan.ilce}</div></div></div><IconButton onClick={() => setEklenenMekanlar(eklenenMekanlar.filter(m => m.id !== mekan.id))} size="small" className="text-red-400 hover:text-red-300"><DeleteOutlineIcon /></IconButton></li>))}</ul>)}
                            </div>
                        </div>
                        <div className="flex justify-end pt-4 pb-8"><Button type="submit" variant="contained" startIcon={<SaveIcon />} size="large" className="bg-gradient-to-r from-teal-500 to-indigo-600 hover:from-teal-600 hover:to-indigo-700 text-white py-3 px-10 font-bold shadow-lg rounded-xl">Rotayı Oluştur</Button></div>
                    </form>
                )}
            </div>

            <Modal open={isModalOpen} onClose={handleCloseModal}><Box sx={alertModalStyle}><Typography variant="h6" className={`font-bold ${isSuccessModal ? 'text-teal-400' : 'text-red-400'}`}>{modalContent.title}</Typography><Typography sx={{ mt: 2, color: 'text-gray-300' }}>{modalContent.message}</Typography><Button onClick={handleCloseModal} variant="contained" className={`mt-4 w-full ${isSuccessModal ? 'bg-teal-500' : 'bg-red-500'}`}>Tamam</Button></Box></Modal>

            {/* --- ROTA DETAY MODALI (SCROLL KALDIRILDI) --- */}
            <Modal open={detayModalOpen} onClose={handleDetayKapat} sx={{ overflowY: 'auto' }}>
                <Box sx={detailModalStyle}>
                    {secilenRotaDetay && (
                        <div className="relative">
                            <IconButton onClick={handleDetayKapat} className="absolute top-2 right-2 text-white bg-black/50 hover:bg-black/80 z-10"><CloseIcon /></IconButton>
                            {secilenRotaDetay.gorsel ? ( <img src={secilenRotaDetay.gorsel} alt={secilenRotaDetay.baslik} className="w-full h-64 object-cover rounded-t-xl" /> ) : (
                                <div className="w-full h-32 bg-gray-800 flex items-center justify-center text-gray-500 rounded-t-xl"><ImageNotSupportedIcon fontSize="large" className="mr-2" /> Görsel Yok</div>
                            )}

                            <div className="p-6 md:p-8 space-y-6">
                                <div>
                                    <div className="flex flex-wrap gap-2 mb-3">
                                        <Chip label={secilenRotaDetay.is_public ? "Sistem Rotası" : "Kullanıcı Rotası"} size="small" sx={{ bgcolor: secilenRotaDetay.is_public ? '#4f46e5' : '#16a34a', color: '#ffffff', fontWeight: 'bold', border: 'none' }} />
                                        <Chip icon={<LocationOnIcon style={{ color: '#38bdf8' }} />} label={`${secilenRotaDetay.il} / ${secilenRotaDetay.ilce}`} size="small" sx={{ bgcolor: '#1f2937', color: '#e5e7eb', border: '1px solid #374151' }} />
                                        {secilenRotaDetay.ortalamaSure && (<Chip icon={<AccessTimeIcon style={{ color: '#fbbf24' }} />} label={secilenRotaDetay.ortalamaSure} size="small" sx={{ bgcolor: '#1f2937', color: '#e5e7eb', border: '1px solid #374151' }} />)}
                                    </div>
                                    <Typography variant="h4" className="text-white font-bold">{secilenRotaDetay.baslik}</Typography>
                                </div>

                                {(secilenRotaDetay.icerdiğiYapılar && secilenRotaDetay.icerdiğiYapılar.length > 0) && (
                                    <div className="bg-indigo-900/30 p-4 rounded-lg border border-indigo-500/30">
                                        <div className="flex items-center gap-2 mb-3 text-indigo-300 font-semibold"><MapIcon fontSize="small" /><span>Ziyaret Edilecek Mekanlar</span></div>
                                        <div className="flex flex-wrap gap-2">{secilenRotaDetay.icerdiğiYapılar.map((yapi, idx) => (<Chip key={idx} label={yapi} size="small" icon={<PlaceIcon style={{ color: '#4fd1c5' }} />} sx={{ bgcolor: '#312e81', color: '#ffffff', border: '1px solid #4338ca', '& .MuiChip-label': { fontWeight: 500 } }} />))}</div>
                                    </div>
                                )}

                                <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700"><Typography className="text-gray-300 leading-relaxed">{secilenRotaDetay.aciklama}</Typography></div>

                                <div className="grid md:grid-cols-2 gap-8">
                                    {secilenRotaDetay.nelerOgreneceksiniz && secilenRotaDetay.nelerOgreneceksiniz.length > 0 && (
                                        <div><Typography variant="h6" className="text-teal-400 mb-3 font-bold border-b border-gray-700 pb-2">Neler Öğreneceksiniz?</Typography><List dense>{secilenRotaDetay.nelerOgreneceksiniz.map((item, index) => (<ListItem key={index} className="pl-0"><ListItemIcon sx={{ minWidth: 32 }}><CheckCircleIcon className="text-teal-500 text-sm" /></ListItemIcon><ListItemText primary={item} primaryTypographyProps={{ className: 'text-gray-300' }} /></ListItem>))}</List></div>
                                    )}
                                    {secilenRotaDetay.mekanDetaylari && secilenRotaDetay.mekanDetaylari.length > 0 && (
                                        <div><Typography variant="h6" className="text-indigo-400 mb-3 font-bold border-b border-gray-700 pb-2">Rota Durakları (Detaylı)</Typography><List>{secilenRotaDetay.mekanDetaylari.map((mekan, index) => (<ListItem key={index} className="bg-gray-800 mb-2 rounded border border-gray-700"><div className="flex items-center w-full"><div className="flex-shrink-0 w-8 h-8 rounded-full bg-indigo-900 text-indigo-200 flex items-center justify-center font-bold mr-3">{index + 1}</div><div><Typography className="text-white font-medium">{mekan.ad}</Typography><Typography variant="caption" className="text-gray-500">{mekan.ilce}</Typography></div></div></ListItem>))}</List></div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Box>
            </Modal>
        </div>
    );
};

export default AdminRotaYonetimi;